import { Component } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { UiService } from "../../../configuration/state/ui.service";

@Component({
	selector: "app-queue-widget-settings",
	template: `
		<ion-list lines="none">
			<ion-item (click)="hide()">
				{{ "WIDGET__HIDE_FROM_DASHBOARD" | transloco }}
			</ion-item>
		</ion-list>
	`,
})
export class QueueWidgetSettingsComponent {
	constructor(
		private popoverController: PopoverController,
		private uiService: UiService,
	) {}

	hide = () => {
		this.uiService.setQueueTimeVisible(false);
		this.popoverController.dismiss();
	};
}
